import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/inventory/warehouses/";

export function getWarehouses() {
  return http.get(apiEndpoint);
}

export function getAllWarehouses() {
  return http.get(apiEndpoint + "all-warehouses");
}

export function getWarehouse(warehouseID) {
  return http.get(apiEndpoint + "warehouse-detail/" + warehouseID);
}

export function getWarehouseMasterDataAPI() {
  return http.get(apiEndpoint + "warehouse-master-data");
}

export function getWarehouseStocks(warehouseID, itemID = 0, varCode = "-") {
  return http.get(apiEndpoint + `stocks/${warehouseID}/${itemID}/${varCode}`);
}

export function getWarehouseItemStocks(itemID, varCode) {
  if (varCode === "") {
    varCode = "-";
  }
  return http.get(`${apiEndpoint}item-stock/${itemID}/${varCode}`);
}

export function saveWarehouse(warehouse) {
  if (warehouse.ID === 0) {
    return http.post(apiEndpoint, warehouse);
  } else {
    return http.put(apiEndpoint, warehouse);
  }
}

export function deleteWarehouse(warehouseID) {
  return http.delete(apiEndpoint + warehouseID);
}

export function restoreWarehouse(warehouseID) {
  return http.put(apiEndpoint + warehouseID);
}
